<template>
  <div class="form-padding bg-white rounded w-full mx-auto" style="width: 473px">
    <div class="enter-x">
      <h2 class="mb-3 text-4xl font-bold text-center enter-x pt-4 pb-8" style="color: #5d66fb">
        {{ getFormTitle }}
      </h2>
    </div>
    <el-form class="enter-x" :model="ruleForm" status-i :rules="rules" ref="login" @keypress.enter="submitForm('ruleForm')">
      <!-- <el-form-item prop="value">
        <el-select v-model="ruleForm.region" placeholder="请选择" style="width: 100%">
          <i slot="prefix" class="el-icon-bell" />
          <el-option v-for="list in courseLimit" :key="list.code" :label="list.name" :value="list.code"> </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="account" class="enter-x relative">
        <el-input type="text" v-model="ruleForm.name">
          <i slot="prefix" class="el-icon-user" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="enter-x relative">
        <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码">
          <i slot="prefix" class="el-icon-lock" />
        </el-input>
      </el-form-item>
      <el-form-item class="enter-x">
        <el-button style="height: 46px; border-radius: 8px; width: 100%" type="primary" size="large" block @click="submitForm('ruleForm')">
          {{ text }}
        </el-button>
      </el-form-item>
      <div class="py-5" style="color: #0c69d7; text-align: center; font-size: 16px">账号有问题? 联系支持中心</div>
    </el-form>
  </div>
</template>
<script>
import * as homeApi from '@/api/home'
import { ERR_OK } from '@/api/index'
import '../../assets/css/login.css'
import { query } from 'quill'
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('账号不能为空'))
      } else {
        callback()
      }
    }
    var validatePa = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('角色不能为空'))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        name: '',
        password: '',
        region: 'teacher'
      },
      courseLimit: [
        {
          name: '教师',
          code: 'teacher'
        },
        {
          name: '家长',
          code: 'parent'
        }
      ],
      rules: {
        name: [{ validator: validateName, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        value: [{ validator: validatePa, trigger: 'blur' }]
      },
      state: false, //提交状态
      text: '登录', //按钮显示
      getFormTitle: '统一登录'
    }
  },
  mounted() {},
  methods: {
    submitForm() {
      this.$refs.login.validate((valid) => {
        if (valid) {
          this.formHandler()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    UsercenterGetInfo() {
      let that = this
      homeApi
        .usercenterinfo()
        .then((res) => {
          that.roleType = res.data.data.roleType
          that.circleUrl = res.data.data.hostUrl
          localStorage.setItem('roleType', res.data.data.roleType)
          localStorage.setItem('authSource', res.data.data.authSource)
          that.authSource = res.data.data.authSource
          localStorage.setItem('userId', res.data.data.userId)
          if (!localStorage.getItem('roleId')) {
            if (res.data.data.roleType == 'teacher') {
              localStorage.setItem('roleId', -1003)
            } else if (res.data.data.roleType == 'school') {
              localStorage.setItem('roleId', -1004)
            } else {
              localStorage.setItem('roleId', -1001)
            }
          }
          if (res.data.data.roleType == 'teacher') {
            localStorage.setItem('teacherId', res.data.data.teacher.id)
            that.names = res.data.data.teacher.name
          } else if (res.data.data.roleType == 'school') {
            that.names = res.data.data.school.name
          } else {
            that.names = res.data.data.parent.name
          }
        })
        .catch(() => {})
    },
    async formHandler() {
      try {
        const { data: res } = await homeApi.userlogin({
          roleType: this.ruleForm.region, //school
          // roleType: 'school',
          account: this.ruleForm.name,
          password: this.ruleForm.password
        })
        // 登录为学生的时跳转
        // if (this.ruleForm.roleType == 'student') {
        //   window.location.href = 'http://live.welaiedu.cn/#/?token=' + res.token
        // }
        // 第一次登录时
        if (res.data.isSettingPwdQuestion == 0) {
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          this.$message.info('检测到您尚未设置密保问题,需要先设置密保问题。设置完密保问题系统会帮您自动登录')
          this.$router.push('/user/checkFirstlogin')
        } else {
          // if (this.ruleForm.region == 'parent') {
          //   this.$router.replace({
          //     path: '/zp/zpset/indicators',
          //     query: {
          //       token: res.data.token,
          //       roleId: res.data.roleList[0].id
          //     }
          //   })
          //   // window.open(
          //   //   homeApi.zpUrl +
          //   //     '?token=' +
          //   //     res.data.token +
          //   //     '&roleId=' +
          //   //     res.data.roleList[0].id
          //   // )
          //   return false
          // }
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          localStorage.setItem('roleId', res.data.roleList[0].id)
          // 提示登录成功
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          // 跳转到工作台
          // this.$router.replace({
          //   path: '/',
          //   query: {
          //     token: res.data.token,
          //     roleId: res.data.roleList[0].id
          //   }
          // })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.form-box {
  background-color: #ffffff;
}
/deep/.el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  padding-left: 45px !important;
  border-radius: 10px !important;
}

/deep/.el-input__prefix {
  line-height: 50px !important;
  font-size: 24px !important;
  left: 10px !important;
}
/deep/.el-input__prefix i {
  font-size: 24px !important;
}
img {
  vertical-align: middle;
  border-style: none;
}

img,
svg,
iframe {
  display: block;
  vertical-align: middle;
}
img {
  max-width: 100%;
  height: auto;
}
.form-padding {
  padding: 2.5rem 1.25rem 5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/login/LoginForm.vue